<script lang="ts" setup>
import tooltipDirective from '@lib/directives/tooltip'

const vTooltip = tooltipDirective

withDefaults(defineProps<{ tooltip: string }>(), {
  tooltip: '',
})
</script>

<template>
  <div v-tooltip="tooltip">
    <slot></slot>
  </div>
</template>
